<template>
  <div class="camp-parent">
    <Mainteinenace></Mainteinenace>
  </div>
</template>

<script>
import Mainteinenace from "@/components/Mainteinence.vue";
export default {
  name: "campaigns",
  components: {
    Mainteinenace
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.camp-parent {
  padding-top: 70px;
  background-color: white;
}
</style>
